import {Theme} from '@innowise-group/ui-kit';
import {getSumStatistic, MainStatistic} from './get-statistics.utility';

export const getOfficeAttendanceTextColor = (attendancePercentage: number, {palette: {attendanceOfficeBadge}}) => {
  if (attendancePercentage >= 90) return attendanceOfficeBadge.greenZone;
  if (attendancePercentage >= 50) return attendanceOfficeBadge.blueZone;
  if (attendancePercentage >= 25) return attendanceOfficeBadge.orangeZone;
  if (attendancePercentage < 25) return attendanceOfficeBadge.redZone;
};

export const getOfficeAttendanceBgColor = (attendancePercentage: number, {palette: {attendanceOfficeBadgeBg}}) => {
  if (attendancePercentage >= 90) return attendanceOfficeBadgeBg.greenZone;
  if (attendancePercentage >= 50) return attendanceOfficeBadgeBg.blueZone;
  if (attendancePercentage >= 25) return attendanceOfficeBadgeBg.orangeZone;
  if (attendancePercentage < 25) return attendanceOfficeBadgeBg.redZone;
};

export const backgroundColorList = (
  statistic: MainStatistic,
  {
    palette: {
      state: {error, warning, success},
      main,
      general: {lightGrey},
      workspaces: {coworkingFree, coworkingBooked, remote},
    },
  }: Theme,
) => {
  const sum = getSumStatistic(statistic);
  return sum > 0
    ? [success.default, warning.default, main.default, error.default, coworkingFree.default, coworkingBooked.default]
    : [lightGrey[80]];
};

const getColorByStatistic = (
  workspaceStatistic: string,
  {
    palette: {
      state: {error, warning, success},
      main,
      workspaces: {coworkingFree, coworkingBooked, remote},
    },
  }: Theme,
) => {
  switch (workspaceStatistic) {
    case 'reserved':
      return warning.default;
    case 'occupied':
      return error.default;
    case 'free':
      return success.default;
    case 'remote':
      return remote.default;
    case 'coworkingFree':
      return coworkingFree.default;
    case 'coworkingBooked':
      return coworkingBooked.default;
    case 'booked':
      return main.default;
  }
};
export default getColorByStatistic;
